//
// PromptElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./DataVisualElementController";
import "@sas-dvr/ltjs-commons/models/data/DataValue";
import "../../models/visualElements/PromptElement";
import "@sas-dvr/ltjs-commons/styles/StyleChain";
import "@sas-dvr/ltjs-commons/models/data/dataset/Column";
import "../../models/promptDefinitions/PromptDefinition";

var PromptElementController = createModule("BIRD_PromptElementController", [40040,40351,40490,40150,40323], EventDispatcher, [
    {
        CURRENT_VALUE_HAS_INVALID_FORMAT: 50016,
        CURRENT_VALUE_CHANGED: 50035,
        MISSING_DYNAMIC_VALUES: 50015,
        INVALID_PROMPTDEFINITION_MEASURE_VARIABLE: 50014,
    },
    ,
    ,
    {
        currentValuesInTermsOfOrderedUniqueRowIndices: [3],
        currentValues: [1],
        currentValue: 1,
    },
    {
        getModel: [1],
        getFormattedMeasure: [7,4],
        getLabel: [7],
        isParameter: [2],
        saveState: [0],
        getCurrentFormattedMeasure: [7],
        showTooltip: [0,[1],4,4],
        validateValue: [1,1],
        isSectionFilter: [2],
        getPromptDefinition: [1],
        getMeasures: [[6]],
        getStyleChain: [1],
        getDefaultValue: [1],
        getDataValueForUserInput: [1,7],
        getFormatName: [7],
        getMeasureColumn: [1],
        getMeasureVariableLabel: [7],
        getColumn: [1],
        getUniqueRowIndicies: [[3]],
        getSelectionStyleChain: [1],
        sortByColumn: [0,7,4],
    },
    {
        _create: [4,1],
        getMissingDisplayString: [7],
    },
    ,
]);
export default PromptElementController;
